var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgActsnotactive({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.0834 9.16665H15.8334V5.83331C15.8334 5.39129 15.6578 4.96736 15.3453 4.6548C15.0327 4.34224 14.6088 4.16665 14.1667 4.16665H10.8334V2.91665C10.8334 2.36411 10.6139 1.83421 10.2232 1.44351C9.83252 1.05281 9.30262 0.833313 8.75008 0.833313C8.19755 0.833313 7.66764 1.05281 7.27694 1.44351C6.88624 1.83421 6.66675 2.36411 6.66675 2.91665V4.16665H3.33341C2.89139 4.16665 2.46746 4.34224 2.1549 4.6548C1.84234 4.96736 1.66675 5.39129 1.66675 5.83331V8.99998H2.91675C4.16675 8.99998 5.16675 9.99998 5.16675 11.25C5.16675 12.5 4.16675 13.5 2.91675 13.5H1.66675V16.6666C1.66675 17.1087 1.84234 17.5326 2.1549 17.8452C2.46746 18.1577 2.89139 18.3333 3.33341 18.3333H6.50008V17.0833C6.50008 15.8333 7.50008 14.8333 8.75008 14.8333C10.0001 14.8333 11.0001 15.8333 11.0001 17.0833V18.3333H14.1667C14.6088 18.3333 15.0327 18.1577 15.3453 17.8452C15.6578 17.5326 15.8334 17.1087 15.8334 16.6666V13.3333H17.0834C17.6359 13.3333 18.1659 13.1138 18.5566 12.7231C18.9473 12.3324 19.1667 11.8025 19.1667 11.25C19.1667 10.6974 18.9473 10.1675 18.5566 9.77684C18.1659 9.38614 17.6359 9.16665 17.0834 9.16665Z",
    fill: "#686868"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgActsnotactive);
export default __webpack_public_path__ + "static/media/actsnotactive.4f2fb714709ce6f692a44e9363a37711.svg";
export { ForwardRef as ReactComponent };